import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/theme-provider";
import { SidebarButton } from "@/layout/components/sidebar-button";

export function ThemeToggle() {
	const { theme, setTheme } = useTheme();

	const toggleTheme = () => {
		setTheme(theme === "dark" ? "light" : "dark");
	};

	return (
		<SidebarButton
			icon={theme === "dark" ? Moon : Sun}
			// label={theme === "dark" ? "Dark" : "Light"}
			onClick={toggleTheme}
		/>
	);
}
